import './LoadingSpinner.css';

function LoadingSpinner() {
  return (
    <span className="loader"></span>
  );
}
export default LoadingSpinner;